import { Outlet } from 'react-router-dom';

const PublicLayout = () => (
	<>
		<Outlet />
	</>
);

export default PublicLayout;
